const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.TAGALYS_CAROUSEL,
      () => {
        this.setupCarousel()
      },
    )
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.75,
              spacing: 20,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.25,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3.65,
              spacing: 20,
            },
          },
          '(min-width: 1600px)': {
            slides: {
              perView: 4,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
